var map = {
	"./(c).svg": 8598,
	"./CarouselHeatingOfLentaSlides/1.png": 5231,
	"./CarouselHeatingOfLentaSlides/2.png": 9956,
	"./CarouselHeatingOfLentaSlides/3.png": 3197,
	"./CarouselHeatingOfLentaSlides/4.png": 3218,
	"./CarouselHeatingOfLentaSlides/5.png": 4763,
	"./CarouselHeatingOfLentaSlides/6.png": 3552,
	"./CarouselHeatingOfLentaSlides/7.png": 7753,
	"./CarouselHeatingOfLentaSlides/8.png": 1998,
	"./DataStructuring.svg": 1580,
	"./Defects.svg": 3184,
	"./EaseOfOperation.svg": 6534,
	"./HeatingOfLentaVideos/1.webm": 541,
	"./HeatingOfLentaVideos/2.webm": 6144,
	"./HeatingOfLentaVideos/3.webm": 5135,
	"./HeatingOfLentaVideos/4.webm": 2658,
	"./HeatingOfLentaVideos/5.webm": 3473,
	"./HeatingOfLentaVideos/6.webm": 4788,
	"./HeatingOfLentaVideos/7.webm": 1843,
	"./HeatingOfLentaVideos/8.webm": 6694,
	"./IncreasedSecurity.svg": 2108,
	"./Joints.svg": 5941,
	"./Observation.svg": 2980,
	"./OperatorAlert.svg": 2688,
	"./PipelineSupport.svg": 6529,
	"./RecordingTheHstory.svg": 7911,
	"./Reports.svg": 923,
	"./SimplificationOfWork.svg": 6545,
	"./UserSupport.svg": 6651,
	"./aboutPage/historyAbout.webp": 6867,
	"./aboutPage/historyBackground.webp": 2550,
	"./aboutPage/missionAbout.webp": 13,
	"./aboutPage/product/AsuScan.webp": 2156,
	"./aboutPage/product/KPS-M.webp": 4212,
	"./aboutPage/product/UTZSH-01.gif": 1484,
	"./aboutPage/product/UTZSH-11.webp": 1749,
	"./backgrounds/404.svg": 4316,
	"./backgrounds/adminbackground.png": 2973,
	"./backgrounds/background1.webp": 2190,
	"./backgrounds/background2.webp": 4127,
	"./backgrounds/background3.webp": 9836,
	"./backgrounds/background4.webp": 3165,
	"./backgrounds/decorate_circles.svg": 6203,
	"./backgrounds/microBackground1.webp": 9032,
	"./backgrounds/microBackground2.webp": 1461,
	"./backgrounds/microBackground3.webp": 9594,
	"./backgrounds/microBackground4.webp": 9079,
	"./backgrounds/slide.jpg": 4719,
	"./backgrounds/slide2.png": 6525,
	"./backgrounds/slide2.webp": 9806,
	"./backgrounds/slide2_black.png": 4809,
	"./backgrounds/slide_black.png": 683,
	"./backgrounds/vacancy.webp": 2456,
	"./cal.svg": 7498,
	"./cardServices/development.png": 1176,
	"./cardServices/implementation.png": 4909,
	"./cardServices/service.png": 2970,
	"./certificate.jpeg": 3704,
	"./circle.svg": 6022,
	"./circles/leftCircle.png": 5401,
	"./circles/miniCircle.png": 3511,
	"./circles/miniCircle2.png": 3941,
	"./circles/rightCircle.png": 6002,
	"./dangerZoneVideos/0.webm": 5918,
	"./dangerZoneVideos/1.webm": 4605,
	"./dangerZoneVideos/2.webm": 5744,
	"./dangerZoneVideos/3.webm": 5503,
	"./dangerZoneVideos/4.webm": 2770,
	"./dangerZoneVideos/5.webm": 8817,
	"./deviceHeatingOfLenta.svg": 1259,
	"./devices.webp": 6108,
	"./devicesDangerZone.svg": 9760,
	"./document-red.png": 1889,
	"./dollar-sign.svg": 6526,
	"./fond.png": 607,
	"./fonts/Geometria-Bold.ttf": 1793,
	"./fonts/Geometria-ExtraBold.ttf": 2459,
	"./fonts/Geometria-ExtraLight.ttf": 2058,
	"./fonts/Geometria-Heavy.ttf": 2629,
	"./fonts/Geometria-Light.ttf": 1904,
	"./fonts/Geometria-Medium.ttf": 6085,
	"./fonts/Geometria-Regular.ttf": 4248,
	"./full_logo.png": 4229,
	"./heatingOfLentaLogo.svg": 5604,
	"./heatingOfLentaScreen1.svg": 1670,
	"./heatingOfLentaScreen2.svg": 1957,
	"./heatingOfLentaScreen3.svg": 324,
	"./heatingOfLentaScreen4.svg": 1675,
	"./icons/404.svg": 505,
	"./icons/ArrowButton.png": 9778,
	"./icons/PC.png": 914,
	"./icons/Subtract_black.svg": 9907,
	"./icons/Subtract_white.svg": 8905,
	"./icons/Union.svg": 1352,
	"./icons/addWorker.svg": 242,
	"./icons/add_product.svg": 604,
	"./icons/arrow.png": 7906,
	"./icons/arrowLeft.png": 6621,
	"./icons/automatics_black.png": 1349,
	"./icons/automatics_light.png": 6060,
	"./icons/basket.png": 3143,
	"./icons/chart_dark.png": 1502,
	"./icons/chart_light.png": 3120,
	"./icons/clock.png": 7915,
	"./icons/data_black.png": 469,
	"./icons/data_light.png": 8300,
	"./icons/delete-icon.svg": 2668,
	"./icons/exit.svg": 5960,
	"./icons/eye-off.svg": 9210,
	"./icons/eye-on.svg": 1172,
	"./icons/hands_dark.png": 2876,
	"./icons/hands_light.png": 8710,
	"./icons/imgBlue.svg": 7188,
	"./icons/imgWhite.svg": 1391,
	"./icons/lamp_dark.png": 2124,
	"./icons/lamp_light.png": 1526,
	"./icons/lang.png": 7749,
	"./icons/loading.svg": 7649,
	"./icons/location.png": 2012,
	"./icons/loupeBlack.svg": 4721,
	"./icons/message.png": 5812,
	"./icons/monitoring_black.png": 3772,
	"./icons/monitoring_light.png": 8414,
	"./icons/moon.png": 9618,
	"./icons/more.png": 5950,
	"./icons/no_image.svg": 9456,
	"./icons/person.png": 9394,
	"./icons/phone.png": 7321,
	"./icons/save.svg": 4660,
	"./icons/search.svg": 4343,
	"./icons/software_black.png": 5426,
	"./icons/software_light.png": 7247,
	"./icons/sun.png": 35,
	"./icons/tg.png": 3410,
	"./icons/user.svg": 698,
	"./icons/videoBlue.svg": 5228,
	"./icons/videoWhite.svg": 1191,
	"./icons/vk.png": 1168,
	"./icons/wiki.svg": 4431,
	"./image.svg": 5125,
	"./img1.png": 1586,
	"./img2.png": 5593,
	"./img3.png": 9840,
	"./img4.png": 2063,
	"./img5.png": 6966,
	"./lentaVideos/testVideo.webm": 3046,
	"./logoDangerZone.svg": 304,
	"./logoLenta.svg": 9001,
	"./medal.png": 1435,
	"./miniCircle.svg": 8107,
	"./no-image.jpg": 7897,
	"./noImage.png": 7730,
	"./pdf.svg": 7920,
	"./scrin1.svg": 5544,
	"./scrin2.svg": 9963,
	"./scrin3.svg": 6090,
	"./scrin4.svg": 3269,
	"./setings.svg": 309,
	"./sliderScrin1.svg": 3591,
	"./sliderScrin2.svg": 2084,
	"./sliderScrin3.svg": 7717,
	"./sliderScrin4.svg": 7306,
	"./sliderScrin5.svg": 5147,
	"./sliderScrin6.svg": 3784,
	"./transmash_logo.svg": 891,
	"./transmash_logo_en.png": 5931,
	"./word-icon.svg": 1084,
	"./zone1.png": 3673,
	"./zone2.png": 5490,
	"./zone3.png": 6619,
	"./zone4.png": 708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;